import { AnalyticsEvent } from '../../core/AnalyticsEvent'
import { CommonEventParams, getCommonParams } from '../../utils/CommonParams'
import { DigitalClubButtonClickedEventSchema } from '../../schemas/buttonClickEvents/DigitalClubClickedEventScheme'

export interface DigialClubClickEventParams extends CommonEventParams {
  BUTTON_NAME: string
  MEMBERSHIP_STATUS: string,
  CURRENT_PLAN_TYPE: string | null;
  BUTTON_TYPE: string;
}

export class DigitalClubButtonClickedEvent extends AnalyticsEvent {
  constructor(params: DigialClubClickEventParams) {
    super(DigitalClubButtonClickedEventSchema(), ['segment'])
    this.createEventObject(params)
  }
}

export async function trackDigitalClubButtonClickedEvent(
  digitalClubButtonClickParams: DigialClubClickEventParams
): Promise<void> {
  try {
    const commonProperties = getCommonParams()
    const params: DigialClubClickEventParams = {
      ...commonProperties,
      ...digitalClubButtonClickParams,
      BUTTON_TYPE: 'link style',
    }
    new DigitalClubButtonClickedEvent(params).track()
  } catch (error) {
    console.error('Error tracking Digital Club Button Clicked Event:', error)
  }
}
